import styled from "styled-components"

export const BannerModuleStyles = styled.section`
  height: 100vh;
  min-height: 600px;
  position: relative;
  padding: 30px var(--borderSpacing);
  background-color: var(--color-ink-pure);

  .container {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    max-width: 1320px;
  }

  .gradient,
  .banner__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  /* warm amber duotone — the house image treatment */
  .banner__image--content {
    filter: sepia(0.85) saturate(1.7) hue-rotate(-12deg) brightness(0.5)
      contrast(1.05);
  }

  /* living amber light layer over the image */
  .banner__shader {
    z-index: 1;
    mix-blend-mode: screen;
    opacity: 0.42;
  }

  .gradient {
    background: linear-gradient(
        to top,
        rgba(11, 10, 8, 0.97) 0%,
        rgba(11, 10, 8, 0.55) 45%,
        rgba(11, 10, 8, 0.3) 100%
      ),
      radial-gradient(
        at 76% 26%,
        var(--color-glow),
        rgba(11, 10, 8, 0) 52%
      );
  }

  .banner__content {
    position: relative;
    z-index: 2;
    min-height: 33vh;
    width: 100%;
    max-width: 860px;
    padding-bottom: clamp(1rem, 6vh, 5rem);

    .eyebrow {
      margin-bottom: 1.5rem;
    }

    h1 {
      margin-top: 0;
      font-size: var(--bannerTitle);
      line-height: 0.95;
      text-shadow: var(--textShadow);
    }

    .banner__lead {
      font-family: var(--font-sans);
      font-size: var(--text-lead);
      line-height: 1.5;
      color: var(--color-paper);
      max-width: 640px;
      margin-bottom: calc(var(--gap) / 1.2);
      text-shadow: var(--textShadow);
    }

    .price {
      margin-top: 0;
      font-size: var(--bannerTitle);
    }
  }

  .banner__btns {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
`
